module.exports = __webpack_public_path__ + "static/media/forward.a98155b9.svg";